/* eslint-disable no-unsafe-optional-chaining */
import { create } from 'zustand';
import {
  // AdditionalInfo,
  CobInfo,
  Demographic,
} from '../types/online-forms.types';

// define the initial state
type State = {
  initialCOB: CobInfo;
  cobInformation: CobInfo;
  demographics: Array<Demographic>;
  dependents: any;
};
const initialState: State = {
  initialCOB: {
    otherInsuranceSource: 'CNE',
    groupNumber: '',
    additionalInsurance: [
      {
        member: {
          firstName: '',
          lastName: '',
          suffix: '',
          gender: '',
          dateOfBirth: '',
        },
        subscriber: {
          member: {
            firstName: '',
            lastName: '',
            suffix: '',
            gender: '',
            dateOfBirth: '',
          },
        },
        insuranceCarrier: '',
        groupNumber: '',
        effectiveDate: '',
        cancelDate: '',
        policyNumber: '',
        relationshipToSubscriber: '',
        employmentStatus: '',
        retirementDate: '',
        custody: '',
        parentWithPrimaryMedicalResponsibility: '',
        dependentInformationCourtOrder: '',
        hasAdditionalInsurance: '',
      },
    ],
    medicare: [
      {
        member: {
          firstName: '',
          lastName: '',
          suffix: '',
          gender: '',
          dateOfBirth: '',
        },
        claimNumber: '',
        eligibilityCriteria: '',
        disabilityBeginDate: '',
        socialSecurityDisabilityIncome: '',
        socialSecurityDisabilityIncomeStartDate: '',
        socialSecurityDisabilityIncomeEndDate: '',
        partACoverage: '',
        partAEffectiveDate: '',
        partACancelDate: '',
        partBCoverage: '',
        partBEffectiveDate: '',
        partBCancelDate: '',
        partCCoverage: '',
        partCCarrierName: '',
        partCPolicyNumber: '',
        partCGroupNumber: '',
        partCEffectiveDate: '',
        partCCancelDate: '',
        partDCoverage: '',
        partDCarrierName: '',
        partDPolicyNumber: '',
        partDGroupNumber: '',
        partDEffectiveDate: '',
        partDCancelDate: '',
        bin: '',
        pcn: '',
        hasMedicare: '',
      },
    ],
  },
  cobInformation: {
    otherInsuranceSource: 'CNE',
    groupNumber: '',
    additionalInsurance: [
      {
        member: {
          firstName: '',
          lastName: '',
          suffix: '',
          gender: '',
          dateOfBirth: '',
        },
        subscriber: {
          member: {
            firstName: '',
            lastName: '',
            suffix: '',
            gender: '',
            dateOfBirth: '',
          },
        },
        insuranceCarrier: '',
        groupNumber: '',
        effectiveDate: '',
        cancelDate: '',
        policyNumber: '',
        relationshipToSubscriber: '',
        employmentStatus: '',
        retirementDate: '',
        custody: '',
        parentWithPrimaryMedicalResponsibility: '',
        dependentInformationCourtOrder: '',
        hasAdditionalInsurance: 'N',
      },
    ],
    medicare: [
      {
        member: {
          firstName: '',
          lastName: '',
          suffix: '',
          gender: '',
          dateOfBirth: '',
        },
        claimNumber: '',
        eligibilityCriteria: '',
        disabilityBeginDate: '',
        socialSecurityDisabilityIncome: '',
        socialSecurityDisabilityIncomeStartDate: '',
        socialSecurityDisabilityIncomeEndDate: '',
        partACoverage: '',
        partAEffectiveDate: '',
        partACancelDate: '',
        partBCoverage: '',
        partBEffectiveDate: '',
        partBCancelDate: '',
        partCCoverage: '',
        partCCarrierName: '',
        partCPolicyNumber: '',
        partCGroupNumber: '',
        partCEffectiveDate: '',
        partCCancelDate: '',
        partDCoverage: '',
        partDCarrierName: '',
        partDPolicyNumber: '',
        partDGroupNumber: '',
        partDEffectiveDate: '',
        partDCancelDate: '',
        bin: '',
        pcn: '',
        hasMedicare: '',
      },
    ],
  },
  demographics: [],
  dependents: [
    {
      additionalInsurance: [
        {
          member: {},
          subscriber: {},
          insuranceCarrier: '',
          groupNumber: '',
          effectiveDate: '',
          cancelDate: '',
          policyNumber: '',
          relationshipToSubscriber: '',
          employmentStatus: '',
          retirementDate: '',
          custody: '',
          parentWithPrimaryMedicalResponsibility: '',
          dependentInformationCourtOrder: '',
          hasAdditionalInsurance: '',
        },
      ],
    },
  ],
};

type MyCobStore = {
  show: boolean;
  demographics: Array<Demographic>;
  dependents: any;
  initialCOB: CobInfo;
  cobInformation: CobInfo;
  demographicsError: any;
  updateCobInformation: (cobInfo: any) => void;
  saveCOBInfo: (cobInformation: any) => void;
  saveDemographicsInfo: (demographics: any) => void;
  saveDemographicError: (demographicsError: any) => void;
  updateDependents: (dependents: any) => void;
  // updateCobInfo: (memberDetails: AdditionalInfo) => void;
  removeCobDependents: (
    cobResponse: any,
    firstName: string,
    lastName: string,
  ) => void;
  canNavigateNext: (show: any) => void;
  resetState: () => void;
};
const useCobStore = create<MyCobStore>((set) => ({
  show: false,
  ...initialState,
  demographicsError: '',
  updateCobInformation: (cobInfo: any) => set(() => cobInfo),
  saveCOBInfo: (cobInformation: any) => set({ cobInformation }),
  saveDemographicsInfo: (demographics: any) => set({ demographics }),
  saveDemographicError: (demographicsError: any) => set({ demographicsError }),
  updateDependents: (dependents: any) => set({ dependents }),

  removeCobDependents: (
    cobResponse: any,
    firstName: string,
    lastName: string,
  ) =>
    set((state: any) => ({
      cobInformation: state.cobInformation.additionalInsurance.splice(
        cobResponse.additionalInsurance.findIndex(
          (dependent: { member: { firstName: string; lastName: string } }) =>
            dependent.member.firstName !== firstName &&
            dependent.member.lastName !== lastName,
        ),
        1,
      ),
    })),
  canNavigateNext: (show: any) => set(() => show),
  resetState: () => {
    set(initialState);
  },
}));

export default useCobStore;
